import { KnowledgeEntityModel } from "src/store/models/entity/knowledge/entity";
import { KnowledgeHelperModel } from "src/store/models/entity/knowledge/helper";

export const encooKnowledgeModels = {
  entity: KnowledgeEntityModel,
  helper: KnowledgeHelperModel,
};
